import dayjs from 'dayjs'

export default () => {
  return {
    fields: {
      startDate: {
        label: 'From',
        type: 'date',
        initial: dayjs().subtract(1, 'month').format('YYYY-MM-DD')
      },
      endDate: {
        label: 'Until',
        type: 'date',
        initial: dayjs().format('YYYY-MM-DD')
      },
      activeOnly: {
        label: 'Exclude inactive pages?',
        type: 'checkbox',
        initial: true
      }
    }
  }
}
